export default {
    home: "首页",
    location: '当前位置',
    aboutUs: '关于兴旺',
    portfolio: '投资组合',
    team: '管理团队',
    news: '新闻中心',
    contact: '联系我们',
    introduce1: '兴旺投资成立于2015年，是专注于硬科技和大消费领域的创业投资机构，总管理规模逾百亿元。',
    introduce2: '兴旺的主要团队来自于鼎晖、美林、中金等国际一流的投资机构和投资银行。兴旺坚持高标准投资，做深度“赋能型”投资人。兴旺过往投资案例包括云从科技、纳睿雷达、移芯通信、星拓微电子、中科酷原、数传集团、博视像元、宝德科技、格林循环、原力动画、玄机科技、白象食品、喜马拉雅、爱康国宾、pidan等市场知名项目。兴旺多次荣登高科技和大消费榜单，获得了业内的高度认可。',
    companyAddress: '公司地址',
    address1Name: '上海地址:',
    address1Des: '上海市浦东新区银城路8号工银大厦',
    address2Name: '深圳地址:',
    address2Des: '深圳市南山区科园路1001号深圳湾创业投资大厦',
    address3Name: '北京地址:',
    address3Des: '北京市朝阳区建国路77号华贸中心2座',
    contactUs: '联系我们',
    contact1: '招聘：hr@xwinvest.com.cn',
    contact2: '公关：pr@xwinvest.com.cn',
    contact3: '发送商业计划书：bp@xwinvest.com.cn',
    manageTeam: '管理团队',
    partner: '合伙人',
    foundingPartner: '创始合伙人',
    team1Name: '熊明旺',
    team1Des: '在创建兴旺投资前，历任鼎晖投资高级总监、九鼎投资投资总监等职，在消费互联网、文娱教育、信息技术、高科技等领域拥有丰富的投资经验;',
    team1Des1: '投资了巨人网络私有化回归、绿地集团借壳上市、喜马拉雅、爱康国宾、云从科技、美柚、原力动画、爱学习教育、数传集团、慧联无限等项目；',
    team1Des2: '被评为“母基金周刊2019年中国股权投资青年领袖GP30”；',
    team1Des3: '熊先生获有北京大学管理学硕士学位。',
    team2Name: '黎媛菲',
    team2Des: '在创建兴旺投资前，历任中金公司投资银行部执行总经理并兼大消费行业组主管、美国汉盛资本副总裁、美林证券亚太高科技、信息技术、媒体组；',
    team2Des1: '黎女士拥有十五年顶级投行和PE投资经验，熟悉国内和海外资本市场的上市和并购各类型资本运作，先后领导了天合光能美国纽交所上市、中电电气美国纳斯达克上市；玖龙纸业香港上市和后续可转债交易、中国交通建设香港上市、中移动海外收购巴基斯坦电信运营商Paktel、都市丽人香港上市；亿联网络A股创业板上市、五粮液非公开发行、泸州老窖非公开发行等重大资本运作项目；在私募股权投资方面，黎女士先后投资了天合光能、喜马拉雅、美柚、原力动画、数传集团、玄机科技、爱学习教育、移芯通信、隅田川咖啡、自嗨锅等市场知名项目；',
    team2Des2: '被评为“36氪2020年中国消费生活领域投资人TOP20”；',
    team2Des3: '黎女士获有复旦大学经济学硕士学位。',
    team3Name: '李平',
    team3Des: '在加入兴旺投资前，历任中化上海发展规划部部门经理、云峰集团投资公司总经理助理、滦海资本董事总经理；',
    team3Des1: '在股权投资和并购方面经验丰富，参与过科创板专著编制，拥有A股董秘资格。主导投资移芯通信、昆宇电源、三德信、正恒动力、丰光精密(430510.OC)等项目，参与宝德计算机(HK08236)、格林循环(002340)、百川畅银(300614)、国林科技(300786)、金石资源(603505并购）、纳睿达等项目；',
    team3Des2: '李先生获有复旦大学经济学硕士学位。',
    team4Name: '曹霞',
    team4Des: '在加入兴旺投资前，历任华兴资本投资经理、钟鼎创投高级投资经理及华映资本执行董事；',
    team4Des1: '拥有丰富的一级市场私募股权基金投资及并购经验，对消费、新零售、金融科技及互联网行业有深刻的认知。主导投资了自嗨锅、i云保、有路、嗨宝贝等市场明星项目，参与投资神州租车、华康保险、德邦物流、晨光文具等项目，以及协助完成了德国柏林水务对中国水厂的收购；',
    team4Des2: '曹女士获有复旦大学经济学硕士学位。',
    more: '更多',
    intro: '兴旺简介',
    idea: '兴旺理念',
    firstPage: '首页',
    lastPage: '末页',
    loadMore: '下拉加载更多',
    detail: '查看详情 >',
    email: '招聘',
    url: '公关',
    tel: '发送商业计划书',
    date: '发布日期',
    honor: '所获殊荣',
    year20161: '“投中-中国新锐私募股权投资机构TOP10”',
    year20162: '“投中-中国互联网产业最佳新锐投资机构TOP30”',
    year20163: '“投中-中国最佳传播领域投资案例TOP10”',
    year20164: '“投中-中国最佳移动互联网领域投资案例TOP10”',
    year20171: '“投中-中国最具成长潜力私募股权投资机构TOP10”',
    year20172: '“投中-最佳教育培训领域投资案例TOP10”',
    year20173: '“投中-最佳娱乐传媒领域投资案例TOP10”',
    year20174: '“猎云网-最佳私募股权投资机构TOP10”',
    year20175: '“猎云网-最佳文化传媒投资机构TOP10”',
    year20181: '“投中-中国人工智能与大数据最佳投资案例TOP10”',
    year20182: '“投中-中国互联网产业最佳投资案例TOP10”',
    year20183: '“猎云网-最佳教育领域投资机构TOP10”',
    year20191: '“36氪-中国最受创业者欢迎私募股权机构TOP50”',
    year20192: '“36氪-中国教育领域最具发现力投资机构TOP10”',
    year20193: '“36氪-中国人工智能领域最具发现力投资机构TOP10”',
    year20201: '“36氪-中国最具成长力私募股权机构TOP10”',
    year20202: '“36氪-中国智能制造领域投资机构TOP20”',
    year20203: '“36氪-中国消费生活领域投资人TOP20”',
    year20204: '“投中-粤港澳大湾区最佳私募股权投资机构TOP30”',
    year20205: '“投中-中国新消费产业最佳投资案例TOP10”',
    year20206: '“投中-中国文化及娱乐传媒产业最佳教育培训领域投资案例TOP10”',
    year20211: '“母基金周刊-2021年度最受LP关注文化消费领域投资机构TOP20”',
    year20212: '“融中-2021年度中国最佳创业投资机构TOP100”',
    year20213: '“浪潮新消费-2021中国新消费成长期投资机构TOP20”',
    year20214: '“投中-2021年度粤港澳大湾区最佳创业投资机构TOP30”',
    year20215: '“投资家-2021年度成长型投资机构TOP20”',
    year20216: '“消费界-2021年度Grow+最具影响力的投资机构”',
    year20217: '“中国风险投资研究院-2021年度中国成长型PE投资机构TOP20”',
    year20218: '“36氪-2021年度最受创业者欢迎创业投资机构 TOP100”',
    year20219: '“第一财经-2021未来生活最佳投资机构TOP10”',
    year202110: '“融资中国-2020-2021年度中国大消费最佳投资机构TOP20”',
    year202111: '“融资中国-2020-2021年度中国大消费领域最佳投资案例”',
    year202112: '“融资中国-2020-2021年度中国先进制造最具成长性投资机构”',
    year202113: '“融资中国-2020-2021年度中国数字传播行业最佳投资机构”',
    year20221: '“投中-2022年度中国人工智能与大数据产业最佳退出案例TOP3”（云从科技）',
    year20222: '“融中-2022年度中国最佳创业投资机构TOP100”',
    year20223: '“母基金研究中心-2022最佳VC基金TOP50”',
    year20224: '“投中-2022年度粤港澳大湾区最佳创业投资机构TOP30”',
    year20225: '“IPO早知道-2022年最佳半导体投资机构TOP15”',
    year20226: '“消费界-2022年度反弹力 最具影响力投资机构TOP10”',
    year20227: '“母基金研究中心-2022最佳人工智能领域投资机构TOP20”',
    year20228: '“母基金研究中心-2022最佳半导体域投资机构TOP30”',
    year20229: '“36氪-2022中国最受LP认可创业投资机构 TOP50”',
    year202210: '“母基金周刊-2022年投资机构软实力排行榜GP组织治理TOP20”',
    year202211: '“创业邦-2022中国创投机构ESG最佳实践奖TOP50”',
    year202212: '“融中-2021-2022年度中国新消费领域投资机构TOP20”',
    year202213: '“融中-2021-2022年度中国集成电路与半导体领域最具成长性投资机构TOP15”',
    year202214: '“第一新声-投资中国2022年Q2中国中国最活跃投资机构IPO榜TOP20”',
    year202215: '“第一新声-投资中国2022年Q2中国先进制造领域最活跃机构TOP20”',
    year202216: '“母基金研究中心-2022VC基金最佳回报TOP50”',
    year202217: '“36氪-2022年中国最受创业者欢迎创业投资机构TOP100”',
    year20231: '“投中2023年度粤港澳大湾区最佳创业投资机构TOP30”',
    year20232: '“融中2023年度中国创业投资机构TOP100”',
    year20233: '“IPO早知道-2023年度最佳半导体芯片投资机构”',
    year20234: '“IC风云榜-2023年度最佳早期投资机构TOP 20”',
    year20235: '“IC风云榜-2023年度最佳行业投资机构奖（人工智能）TOP 20”',
    year20236: '“母基金研究中心-2023最佳VC基金 TOP 23”',
    year20237: '“融中-2023大湾区创业投资机构TOP 50”',
    year20238: '“创业邦-2023最受赞赏的创业投资机构”',
    year20239: '“创业邦-2023创投机构ESG最佳实践奖”',
    year202310: '“超新星-2023超新星之投资机构金伯乐奖TOP 50”',
    year202311: '“超新星-2023超新星榜单半导体行业TOP 50”（电科星拓）',
    year202312: '“超新星-2023超新星榜单半导体行业TOP 50”（ 芯启源）',
    year202313: '“甲子光年-2023年度中国最佳硬科技创业投资机构TOP 50”',
    year202314: '“甲子光年-2022-2023 年度半导体与集成电路最佳投资机构 TOP30”',
    year202315: '“母基金研究中心-2023 VC基金最佳回报Top50”',
    year202316: '“母基金研究中心-2023 最佳半导体领域投资机构Top30”',
    year202317: '“母基金研究中心-2023 最佳人工智能领域投资机构Top20”',
    year202318: '“投资家网-2022-2023年度最佳创业投资机构TOP60”',
    year202319: '“硬科技亚洲评论-2023年亚洲半导体投资机构TOP30”',
    year202320: '“投资界-2023投资界科创100”（移芯通信）',
    year202321: '“36氪-2023年中国最受创业者欢迎创业投资机构 TOP100”',
    year202322: '“母基金周刊-2023年投资机构软实力排行榜新经济TOP20”',
    year202323: '“融中-2022-2023年度中国新消费领域最佳投资机构Top10”',
    year202324: '“融中-2022-2023年度中国集成电路与半导体领域卓越投资机构Top20”',
    year20241: '“36kr-中国股权投资行业创业投资机构100”',
    year20242: '“2024新质生产力投资机构软实力排行榜价值创造TOP20”',
    year20243: '“2024中国股权投资年中榜单中国最佳创业投资机构综合榜TOP50”',
    year20244: '“甲子光年-2024年度中国最佳科技创业投资机构TOP 50”',
    year20245: '“企名片—2024最佳早期投资机构TOP 50”',
    year20246: '“2024中国榜样家族办公室 青牛奖榜单 最受家族办公室关注 创业投资机构 Top30”',
    year20247: '“IPO早知道-2024年度最佳半导体芯片投资机构”',
    year20248: '“消费纪-Blooming Brands 年度·品牌最佳投资机构TOP15”',
    year20251: '“沙利文中国-2025大消费年度投资机构”',
    year20252: '“LP CLUB榜 最佳炬火开源早期投资机构 TOP 30”',


    attention: '关注公众号'
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh-CN.js